module.exports = __webpack_public_path__ + "static/findingTheS-216663e331130c4464fce670e58fcf96.jpg";